<script lang="ts">
	import SkeletonBlock from '$lib/components/atoms/skeleton/SkeletonBlock.svelte';
	import SkeletonText from '$lib/components/atoms/skeleton/SkeletonText.svelte';
	import { generateRandomWords } from '$lib/utils/generateRandomWords';
</script>

<div class="flex flex-col gap-2 min-w-65">
	<SkeletonText minWords={2} maxWords={2} minWordLength={1} maxWordLength={20} />

	<div class="route-card-data gap-1 w-full text-left">
		<div class="route-card-duration flex gap-1 flex-items-baseline">
			<SkeletonBlock width="90px" height="33px" />
		</div>

		<div class="route-card-distance">
			<SkeletonText
				text={generateRandomWords({
					minWords: 1,
					maxWords: 1,
					minWordLength: 10,
					maxWordLength: 10,
				})}
				class="h-5.5"
			/>
		</div>

		<div class="route-card-co2">
			<SkeletonText
				text={generateRandomWords({
					minWords: 1,
					maxWords: 1,
					minWordLength: 10,
					maxWordLength: 10,
				})}
				class="h-5.5"
			/>
		</div>

		<div class="route-card-costs items-baseline">
			<SkeletonBlock width="50px" height="33px" class="hidden md:block" />

			<SkeletonText
				class="h-5.5 md:hidden"
				text={generateRandomWords({
					minWordLength: 20,
					maxWordLength: 30,
					minWords: 1,
					maxWords: 1,
				})}
			/>
		</div>

		<div class="route-card-included-costs hidden md:block">
			<SkeletonText
				class="h-5.5"
				text={generateRandomWords({
					minWordLength: 20,
					maxWordLength: 30,
					minWords: 1,
					maxWords: 1,
				})}
			/>
		</div>
	</div>
</div>
<div
	class="route-card-detail flex items-center p-4 justify-center b-t-1 b-t-solid md:b-l-1 md:b-l-solid md:b-t-0 border-transparent mx-4 md:mx-0 md:my-0.5 gap-1"
>
	<SkeletonBlock width="70px" height="22px" />
</div>

<style>
	.route-card-data {
		display: grid;
		grid-template-areas: 'duration distance' 'costs costs' 'co2 co2';
	}

	.route-card-distance {
		grid-area: distance;
	}

	.route-card-duration {
		grid-area: duration;
	}

	.route-card-included-costs {
		grid-area: included-costs;
	}

	.route-card-co2 {
		grid-area: co2;
	}

	.route-card-costs {
		grid-area: costs;
	}

	@media screen and (min-width: 960px) {
		.route-card-data {
			display: grid;
			grid-template-areas:
				'duration costs'
				'distance included-costs'
				'co2 co2';
		}
		.route-card-detail {
			height: calc(100% - 4px);
		}
	}
</style>
